import * as React from "react";
import { HISTORY_TABLE_HEADER_HEIGHT } from "../util/constants";

const LINE_HEIGHT = 14;

type IProps = {
    topLabel?: React.ReactNode;
    date?: string;
    patientName?: string;
    align?: "left" | "center";
};

const lineStyle: React.CSSProperties = {
    lineHeight: `${LINE_HEIGHT}px`,
    minHeight: LINE_HEIGHT,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
};

export const HistoryTableHeaderLabel = ({ topLabel, date, patientName, align = "center" }: IProps) => (
    <div
        style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: align === "left" ? "flex-start" : "center",
            height: HISTORY_TABLE_HEADER_HEIGHT - 16,
            minHeight: HISTORY_TABLE_HEADER_HEIGHT - 16,
            width: "100%",
            boxSizing: "border-box",
            textAlign: align,
        }}
    >
        <div style={{ ...lineStyle, fontWeight: 500 }}>{topLabel ?? "\u00A0"}</div>
        <div style={{ ...lineStyle, marginTop: 2 }}>{date ?? "\u00A0"}</div>
        <div
            style={{
                ...lineStyle,
                marginTop: 2,
                fontSize: 11,
            }}
        >
            {patientName ?? "\u00A0"}
        </div>
    </div>
);
